var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPages = function SvgPages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.241 22.627c-.378.874-1.278 1.373-2.23 1.373h-6.257q.06-.17.109-.35a4.12 4.12 0 0 0-.901-3.788c.325-2.65.528-5.364.652-7.508.062-1.064-1.241-1.42-1.71-.467-.947 1.92-2.105 4.374-3.125 6.834a4.04 4.04 0 0 0-2.642 2.823A4.1 4.1 0 0 0 12.246 24H5.989c-.952 0-1.852-.5-2.23-1.373a13.3 13.3 0 0 1-1.092-5.294C2.667 9.97 8.637 4 16 4s13.333 5.97 13.333 13.333c0 1.881-.39 3.671-1.092 5.294",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.614 12.353c.062-1.064-1.241-1.419-1.71-.466-.947 1.92-2.105 4.374-3.125 6.834a4.04 4.04 0 0 0-2.642 2.822c-.571 2.17.695 4.402 2.828 4.984s4.326-.707 4.898-2.878a4.12 4.12 0 0 0-.901-3.788c.325-2.65.528-5.364.652-7.508"
  })));
};
export default SvgPages;